import block_icons from '../icons/advance_heading.js';
import color_palette_list from '../gb-helper/color_palette';
import { font_family_detailed, all_font_families } from '../gb-helper/font_family_detailed';
// import './style.scss'
const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls, BlockControls,
    AlignmentToolbar,
    BlockAlignmentToolbar, RichText } = wp.blockEditor;
const { PanelBody, PanelRow, SelectControl, Dashicon, Card, CardBody, Button,
    RangeControl, ColorIndicator, ColorPalette, StyleSheet } = wp.components;

registerBlockType('blocksbakery/advanced-heading', {
    title: __('Advanced Heading', 'blocks-bakery'),
    description: __(
        'Advance heading allows you to use attractive and trendy headings in combination with subheadings and a separator between them. You are able to choose the heading tags with the manual settings and customization.',
        'blocks-bakery'
    ),

    // common, formatting, layout, widgets, embed
    category: 'blocks-bakery',
    icon: block_icons.heading_icon, 
    keywords: [
        __('Advance', 'blocks-bakery'),
        __('Heading', 'blocks-bakery')
    ],
    supports: {
        html: false
    },
    attributes: {
        content_heading: {
            type: "string",
        },
        seperator_content: {
            type: "html"
        },
        content_subheading: {
            type: "string",
        },
        heading: {
            type: 'html',
            default: 'h2'
        },
        color_heading: {
            type: "string",
  
        },
        color_subheading: {
            type: "string",
 
        },
        color_seperator: {
            type: "string",
            
       
        },
        seperator_style: {
            type: "html",
            default: 'solid'
        },
        seperator_thickness: {
            type: "number",
            default: 1
        },
        margin_left: {
            type: 'string',
            default: 'auto'
        },
        margin_right: {
            type: 'string',
            default: 'auto'
        },
        seperator_width: {
            type: "number",
            default: 20,
        },
        seperator_bt_margin: {
            type: "number",
            default: 15,
        },
        heading_bt_margin: {
            type: "number",
            default: 15,
        },
        heading_size: {
            type: "number",
            default:30,
        },
        heading_weight: {
            type: "string",
            default:"regular"
        },
        line_height: {
            type: "number",
            default: 30
        },
        font_family: {
            type: "string",
            default: 'ABeeZee'
        },
        subheading_size: {
            type: "number",
            default: 30
        },
        subheading_weight: {
            type: "string",
            default:"regular"
        },
        subline_height: {
            type: "number",
            default: 30
        },
        subfont_family: {
            type: "string",
            default: 'ABeeZee'
        },
        text_alignment: {
            type: 'html',
            default: "center"
        },
        fontsize_px_em: {
            type: 'string',
            default: 'px'
        },
        line_height_px_em: {
            type: 'string',
        },
        sub_fontsize_px_em: {
            type: 'string',
            default: 'px'
        },
        sub_line_height_px_em: {
            type: 'string',
            default: 'px'
        },
        sp_width_em_per: {
            type: 'string',
            default: '%'
        },
        set_p_range:{
            type:"number",
            default:100,
        }
    },

    edit: (props) => {


        var index = font_family_detailed.findIndex(x => x.family === props.attributes.font_family);
        var font_weight = font_family_detailed[index].variants
        var font_weight_list = []
        for (var i = 0; i < font_weight.length; i++) {
            font_weight_list.push({ label: font_weight[i], value: font_weight[i] })
        }
        var sub_index = font_family_detailed.findIndex(y => y.family === props.attributes.subfont_family);
        var font_sub_weight = font_family_detailed[sub_index].variants
        var font_weight_sub_list = []
        for (var i = 0; i < font_sub_weight.length; i++) {
            font_weight_sub_list.push({ label: font_sub_weight[i], value: font_sub_weight[i] })
        }

        const card_body = () => {
            var x = document.getElementById("myDIV");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        }
        const card_subody = () => {
            var x = document.getElementById("myDIV1");
            if (x.style.display === "none") {
                x.style.display = "block";
            } else {
                x.style.display = "none";
            }
        }
        const sp_width_px = () => {
            var sp_px = document.getElementById('sp-px')
            var sp_per = document.getElementById('sp-per')
            sp_px.style.textDecoration = "underline"
            sp_per.style.textDecoration = "none"
           
            props.setAttributes({ set_p_range : 500,sp_width_em_per: 'px'})
          
        }
        const sp_width_per = () => {
            var sp_px = document.getElementById('sp-px')
            var sp_per = document.getElementById('sp-per')
            sp_per.style.textDecoration = "underline"
            sp_px.style.textDecoration = "none"
    
            props.setAttributes({ set_p_range : 100,sp_width_em_per: '%'})
        }




        const px_heading = () => {
            var head_fs_px = document.getElementById("heading-fs-px")
            var head_fs_em = document.getElementById("heading-fs-em")
            head_fs_em.style.textDecoration = "none";
            head_fs_px.style.textDecoration = "underline"
            props.setAttributes({ fontsize_px_em: 'px' })
        }
        const em_heading = () => {
            var head_fs_px = document.getElementById("heading-fs-px")
            var head_fs_em = document.getElementById("heading-fs-em")
            head_fs_px.style.textDecoration = "none";
            head_fs_em.style.textDecoration = "underline"
            props.setAttributes({ fontsize_px_em: 'em' })
        }
        const headingLineheightPx = () => {
            var head_ln_px = document.getElementById("heading-ln-px")
            var head_ln_em = document.getElementById("heading-ln-em")
            head_ln_em.style.textDecoration = "none";
            head_ln_px.style.textDecoration = "underline"
            props.setAttributes({ line_height_px_em: 'px' })
        }
        const headingLineheightEm = () => {
            var head_ln_px = document.getElementById("heading-ln-px")
            var head_ln_em = document.getElementById("heading-ln-em")
            head_ln_px.style.textDecoration = "none";
            head_ln_em.style.textDecoration = "underline"
            props.setAttributes({ line_height_px_em: 'em' })
        }
        const px_subheading = () => {
            var subhead_fs_px = document.getElementById("subheading-fs-px")
            var subhead_fs_em = document.getElementById("subheading-fs-em")
            subhead_fs_em.style.textDecoration = "none"
            subhead_fs_px.style.textDecoration = "underline"
            props.setAttributes({ sub_fontsize_px_em: 'px' })
        }
        const em_subheading = () => {
            var subhead_fs_px = document.getElementById("subheading-fs-px")
            var subhead_fs_em = document.getElementById("subheading-fs-em")
            subhead_fs_px.style.textDecoration = "none"
            subhead_fs_em.style.textDecoration = "underline"
            props.setAttributes({ sub_fontsize_px_em: 'em' })
        }
        const pxlineh_u_subheading = () => {
            var subhead_ln_px = document.getElementById("subheading-ln-px")
            var subhead_ln_em = document.getElementById("subheading-ln-em")
            subhead_ln_em.style.textDecoration = "none"
            subhead_ln_px.style.textDecoration = "underline"
            props.setAttributes({ sub_line_height_px_em: 'em' })
        }
        const emlineh_u_subheading = () => {
            var subhead_ln_px = document.getElementById("subheading-ln-px")
            var subhead_ln_em = document.getElementById("subheading-ln-em")
            subhead_ln_px.style.textDecoration = "none"
            subhead_ln_em.style.textDecoration = "underline"
            props.setAttributes({ sub_line_height_px_em: 'px' })
        }
        const reset = () => {
         
            props.setAttributes({font_family:"ABeeZee"});
            props.setAttributes({heading_size:30});
            props.setAttributes({heading_weight:"regular"});
            props.setAttributes({line_height:1.5});
        }
        const subHeading = () => {
    
            props.setAttributes({subfont_family:"ABeeZee"});
            props.setAttributes({subheading_size:30});
            props.setAttributes({subheading_weight:"regular"});
            props.setAttributes({subline_height:30});
        }
        const hr_align = (val) => {
            if (val === 'center') {
                props.setAttributes({ margin_left: 'auto' })
                props.setAttributes({ margin_right: 'auto' })
            }
            else if (val === 'left') {
                props.setAttributes({ margin_left: '0px' })
                props.setAttributes({ margin_right: 'auto' })
            }
            else if (val === 'right') {
                props.setAttributes({ margin_left: 'auto' })
                props.setAttributes({ margin_right: '0px' })
            }
        }
        return (
            <React.Fragment>
                <InspectorControls>
                    <PanelBody title={__('Advanced Heading', 'blocks-bakery')} initialOpen={true}>
                        <PanelRow>     <h2>Heading</h2></PanelRow>
                        <SelectControl
                            label={__("Heading Tag", "blocks_bakery")}
                            value={props.attributes.heading}
                            options={[
                                { label: 'h1', value: 'h1' },
                                { label: 'h2', value: 'h2' },
                                { label: 'h3', value: 'h3' },
                                { label: 'h4', value: 'h4' },
                                { label: 'h5', value: 'h5' },
                                { label: 'h6', value: 'h6' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ heading: new_val })
                            }} />
                        <PanelRow>
                            <p>Typography</p>
                            <div>
                                <Button onClick={reset} style={{ padding: 0 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={card_body} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="myDIV" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={px_heading} id="heading-fs-px" style={{ fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={em_heading} id="heading-fs-em" style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                <div className="range-controller-main">
                                    <div className="textcoloring">
                                    </div>
                                    <div className="range-controler" style={{ display: "flex" }}>
                                        {/* <PanelRow> */}

                                        <div style={{ marginRight: "10px", width: "100%" }}>
                                            <RangeControl
                                                beforeIcon="editor-textcolor"
                                                initialPosition={30}
                                                min={0}
                                                max={100}
                                                step={0.1}
                                                onChange={(new_val) => {
                                                    props.setAttributes({ heading_size: new_val })
                                                }}
                                                value={props.attributes.heading_size}
                                                style={{ marginBottom: "0px" }}
                                            />
                                        </div>
                                        <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                                        }}
                                            onClick={() => {
                                                // var reset_heading_font_size = document.getElementsByClassName("gb-ad-heading-content-heading")[0];
                                                // reset_heading_font_size.style.fontSize = "";
                                                props.setAttributes({ heading_size: 30 })
                                            }}> Reset
                                        </Button>
                                        {/* </PanelRow> */}
                                    </div>

                                    <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ font_family: new_val })
                                        }}
                                        value={props.attributes.font_family}
                                    />
                                    <SelectControl
                                        label="Font Weight"
                                        options={font_weight_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ heading_weight: new_val })
                                        }}
                                        value={props.attributes.heading_weight}
                                    />

                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: 30 }}>Line Height</p>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                        <Button onClick={headingLineheightPx} id="heading-ln-px" style={{ fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                        <Button onClick={headingLineheightEm} id="heading-ln-em" style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                    </div>
                                    <div style={{ display: "flex" }}>
                                        <div style={{ marginRight: "10px", width: "100%" }}>
                                            <RangeControl

                                                beforeIcon="editor-textcolor"
                                                initialPosition={30}
                                                step={0.1}
                                                min={0}
                                                max={100}
                                                onChange={(new_val) => {
                                                    props.setAttributes({ line_height: new_val })
                                                }}
                                                value={props.attributes.line_height}
                                            />
                                        </div>

                                        <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                                        }}
                                            onClick={() => {
                                                var reset_heading_line_height = document.getElementsByClassName("gb-ad-heading-content-heading")[0];
                                                reset_heading_line_height.style.lineHeight = "";
                                                props.setAttributes({ line_height: 30 })
                                            }}> Reset
                                        </Button>

                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        {/* end of the cardbody */}
                        <div style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <label>{__("Heading color", "blocks-bakery")}</label>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.color_heading }}
                            />
                        </div>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ color_heading: new_val })
                            }}
                            value={props.attributes.color_heading}
                        />
                        <hr />
                        <p>Sub Heading</p>
                        <div style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <PanelRow>
                                <p>Typography</p>
                                <div>
                                    <Button onClick={subHeading} style={{ padding: 0 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                    <Button><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={card_subody} /></span></Button>
                                </div>
                            </PanelRow>
                            {/* card body start */}
                            <Card id="myDIV1" style={{ display: "none" }}>
                                <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: 46 }}>Font Size</p>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                        <Button onClick={px_subheading} id="subheading-fs-px" style={{ fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                        <Button onClick={em_subheading} id="subheading-fs-em" style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                    </div>
                                    <div className="range-controller-main">
                                        <div className="textcoloring">
                                        </div>
                                        <div className="range-controler" style={{ display: "flex" }}>
                                            <div style={{ marginRight: "10px", width: "100%" }}>
                                                <RangeControl

                                                    beforeIcon="editor-textcolor"
                                                    initialPosition={30}
                                                    min={0}
                                                    max={100}
                                                    step={0.1}
                                                    onChange={(new_val) => {
                                                        props.setAttributes({ subheading_size: new_val })
                                                    }}
                                                    value={props.attributes.subheading_size}
                                                />
                                            </div>

                                            <Button style={{
                                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                                            }}
                                                onClick={() => {
                                                    // var reset_sub_heading_font_size = document.getElementsByClassName("gb-ad-heading-sub-heading")[0];
                                                    // reset_sub_heading_font_size.style.fontSize = "";
                                                    props.setAttributes({ subheading_size: 30})
                                                }}> Reset
                                            </Button>

                                        </div>
                                        <SelectControl
                                            label="Font Family"
                                            options={all_font_families}
                                            onChange={(new_val) => {
                                                props.setAttributes({ subfont_family: new_val })
                                            }}
                                            value={props.attributes.subfont_family}
                                        />
                                        <SelectControl
                                            label="Font Weight"
                                            options={font_weight_sub_list}
                                            onChange={(new_val) => {
                                                props.setAttributes({ subheading_weight: new_val })
                                            }}
                                            value={props.attributes.subheading_weight}
                                        />
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <p style={{ marginRight: 30 }}>Line Height</p>
                                            <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                                <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                            <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                                <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                            <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                                <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                            <Button onClick={pxlineh_u_subheading} id="subheading-ln-px" style={{ fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                            <Button onClick={emlineh_u_subheading} id="subheading-ln-em" style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                        </div>


                                        <div style={{ display: "flex" }}>

                                            <div style={{ marginRight: "10px", width: "100%" }}>
                                                <RangeControl

                                                    beforeIcon="editor-textcolor"
                                                    initialPosition={30}
                                                    step={0.1}
                                                    min={0}
                                                    max={100}
                                                    onChange={(new_val) => {
                                                        props.setAttributes({ subline_height: new_val })
                                                    }}
                                                    value={props.attributes.subline_height}
                                                />
                                            </div>

                                            <Button style={{
                                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                                            }}
                                                onClick={() => {
                                                    var reset_sub_heading_line_height = document.getElementsByClassName("gb-ad-heading-sub-heading")[0];
                                                    reset_sub_heading_line_height.style.lineHeight = "";
                                                    props.setAttributes({ subline_height: 30 })
                                                }}> Reset
                                            </Button>


                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <label>{__("Sub Heading Color", 'blocks-bakery')}</label>
                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.color_subheading }}
                            />
                        </div>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ color_subheading: new_val })
                            }}
                            value={props.attributes.color_subheading}
                        />
                        <hr />
                    </PanelBody>

                    <PanelBody title={__('Separator', 'blocks-bakery')} initialOpen={false}>
                        <SelectControl
                            label="Style"
                            options={[
                                { label: 'None', value: 'None' },
                                { label: 'Solid', value: 'solid' },
                                { label: 'Double ', value: 'double' },
                                { label: 'Dashed', value: 'dashed' },
                                { label: 'Dotted', value: 'dotted' }
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ seperator_style: new_val })
                            }}
                            value={props.attributes.seperator_style}
                        />
                        <p>Thickness(px)</p>
                        <div style={{ display: 'flex' }}>
                            <div style={{ marginRight: '10px', width: "100%" }}>
                                <RangeControl
                                    initialPosition={1}
                                    min={1}
                                    max={20}
                                    onChange={(new_val) => {
                                        props.setAttributes({ seperator_thickness: new_val })
                                    }}
                                    value={props.attributes.seperator_thickness}
                                />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                            }}
                                onClick={() => {
                                  
                                    props.setAttributes({ seperator_thickness: 1 })
                                }}> Reset
                            </Button>
                        </div>
                        <PanelRow>
                            <p>Width</p>
                            <div>
                                <Button id="sp-px" onClick={sp_width_px} style={{ padding: 0 }}>px</Button>
                                <Button id="sp-per" onClick={sp_width_per} >%</Button>
                            </div>
                        </PanelRow>
                        <div id="sep_width">
                        <div style={{ display: 'flex' }}>
                            <div style={{marginRight:'10px', width:'100%'}}>
                                <RangeControl
                                    initialPosition={20}
                                    min={0}
                                    max={props.attributes.set_p_range}
                                    onChange={(new_val) => {
                                        props.setAttributes({ seperator_width: new_val })
                                    }}

                                    value={props.attributes.seperator_width}
                                />
                            </div>
                            <Button style={{
                                background: 'transparent', border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                            }}
                                onClick={() => {
                                 
                                    props.setAttributes({ seperator_width: 20 })
                                }}> Reset
                            </Button>
                        </div>
                          </div>


                      



 
                        <div style={{ paddingTop: 10, paddingBottom: 10 }}>

                            <label>{__("Separator Color", 'blocks-bakery')}</label>

                            <ColorIndicator
                                style={{ backgroundColor: props.attributes.color_seperator }}
                            />
                        </div>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ color_seperator: new_val })
                            }}
                            value={props.attributes.color_seperator}

                        />
                    </PanelBody>
                    <PanelBody title={__('Spacing', 'blocks-bakery')} initialOpen={false}>
                    <div className="range-controler" style={{ display: "flex" }}>
                                        {/* <PanelRow> */}

                                        <div style={{ marginRight: "10px", width: "100%" }}>
                        <RangeControl
                       
                            label="Heading Bottom Spacing (px)"
                            initialPosition={15}
                            min={0}
                            max={500}
                            onChange={(new_val) => {
                                props.setAttributes({ heading_bt_margin: new_val })
                            }}
                            value={props.attributes.heading_bt_margin}
                        />
                        </div>
                                            <Button style={{
                        background: 'transparent', 
                        marginTop:"25px",
                        border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                    }}
                        onClick={() => {
                    
                            props.setAttributes({ heading_bt_margin: 15 })
                        }}> Reset
                    </Button>
                        </div>
                        <div className="range-controler" style={{ display: "flex" }}>
                                        {/* <PanelRow> */}

                                        <div style={{ marginRight: "10px", width: "100%" }}>
                        <RangeControl
                         
                            label="Separator Bottom Spacing (px)"
                            initialPosition={15}
                            min={0}
                            max={500}
                            onChange={(new_val) => {
                                props.setAttributes({ seperator_bt_margin: new_val })
                            }}
                            value={props.attributes.seperator_bt_margin}
                        />
                        </div>

                      
                                   <Button style={{
                        background: 'transparent',
                        marginTop:"25px",
                        border: '1px solid #007cba', fontSize: '11px', width: "22%", height: "31px", color: "#007cba"
                    }}
                        onClick={() => {
                    
                            props.setAttributes({ seperator_bt_margin: 15 })
                        }}> Reset
                    </Button>
                    </div>
                    </PanelBody>
                </InspectorControls>
                <div className={props.className}>
                    <BlockControls>
                        <AlignmentToolbar
                            value={props.attributes.text_alignment}
                            onChange={(new_val) => {
                                props.setAttributes({ text_alignment: new_val });
                                hr_align(new_val)
                            }} />
                    </BlockControls>
                    <div className="gb-ad-heading-main">

                        <RichText
                            className="gb-ad-heading-content-heading"

                            tagName={props.attributes.heading}
                            value={props.attributes.content_heading}
                            onChange={(new_val) => {
                                props.setAttributes({ content_heading: new_val })
                            }}
                            placeholder={__('Write a Heading', 'blocks-bakery')}
                            style={{
                                textAlign: props.attributes.text_alignment,
                                color: props.attributes.color_heading, marginBottom: props.attributes.heading_bt_margin, fontSize: props.attributes.heading_size + props.attributes.fontsize_px_em,
                                fontWeight: props.attributes.heading_weight, lineHeight: props.attributes.line_height + props.attributes.line_height_px_em, fontFamily: props.attributes.font_family
                            }}
                        />
                        <div className="gb-ad-heading-seperator"
                            style={{
                                margin: 'auto', textAlign: props.attributes.text_alignment,
                                marginLeft: props.attributes.margin_left, marginRight: props.attributes.margin_right,
                            
                              width: props.attributes.seperator_width + props.attributes.sp_width_em_per, marginBottom: props.attributes.seperator_bt_margin,
                                    borderTopStyle:props.attributes.seperator_style, borderTopWidth:props.attributes.seperator_thickness,
                                    borderTopColor:props.attributes.color_seperator
                 
                            }}></div>
               
                  

                        <RichText className='gb-ad-heading-sub-heading'
                            id="width_sepeartor_advace"
                            value={props.attributes.content_subheading}
                            onChange={(new_val) => {
                                props.setAttributes({ content_subheading: new_val })
                            }}
                            tagName="p"
                            placeholder={__('Write a Description', 'blocks-bakery')}
                            style={{
                                textAlign: props.attributes.text_alignment,
                                color: props.attributes.color_subheading, fontSize: props.attributes.subheading_size + props.attributes.sub_fontsize_px_em,
                                fontWeight: props.attributes.subheading_weight, lineHeight: props.attributes.subline_height + props.attributes.sub_line_height_px_em, fontFamily: props.attributes.subfont_family
                            }}
                        />
                    </div>
                </div>
            </React.Fragment>
        )
    },

    save: (props) => {
        return (
            <div className="gb-ad-heading-main">
                <RichText.Content
                    className="gb-ad-heading-content-heading"

                    tagName={props.attributes.heading}
                    value={props.attributes.content_heading}

                    placeholder={__('Write a Heading', 'blocks-bakery')}
                    style={{
                        textAlign: props.attributes.text_alignment,
                        color: props.attributes.color_heading, marginBottom: props.attributes.heading_bt_margin, fontSize: props.attributes.heading_size + props.attributes.fontsize_px_em,
                        fontWeight: props.attributes.heading_weight, lineHeight: props.attributes.line_height + props.attributes.line_height_px_em, fontFamily: props.attributes.font_family
                    }}
                />
                 <div className="gb-ad-heading-seperator"
                            style={{
                                margin: 'auto', textAlign: props.attributes.text_alignment,
                                marginLeft: props.attributes.margin_left, marginRight: props.attributes.margin_right,
                               width: props.attributes.seperator_width + props.attributes.sp_width_em_per, marginBottom: props.attributes.seperator_bt_margin,
                               borderTopStyle:props.attributes.seperator_style, borderTopWidth:props.attributes.seperator_thickness,
                               borderTopColor:props.attributes.color_seperator
                   
                            }}>
                                </div>
                  

              
                <RichText.Content
                    className='gb-ad-heading-sub-heading'
                    value={props.attributes.content_subheading}

                    tagName="p"

                    placeholder={__('Write a Description', 'blocks-bakery')}
                    style={{
                        textAlign: props.attributes.text_alignment,
                        color: props.attributes.color_subheading, fontSize: props.attributes.subheading_size + props.attributes.sub_fontsize_px_em,
                        fontWeight: props.attributes.subheading_weight, lineHeight: props.attributes.subline_height + props.attributes.sub_line_height_px_em, fontFamily: props.attributes.subfont_family
                    }}
                />
            </div>
        )
    }
})